import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import Button from '../../components/Button.js';
import Title from '../../components/Title.js';
import IconCount from '../../components/icons/IconCount.js';
import BudgetOperationTopPart3Part1 from './BudgetOperationTopPart3Part1.js';
import ApiService from '../../services/ApiService.js';
import { getWords } from '../../utils/get-words.js';
import { isValid } from '../../utils/is-valid.js';

const BudgetOperationTopPart3 = ReactRouterDOM.withRouter(function ({ budgetOperation }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);
  const [path, setPath] = React.useState({});
  const [body, setBody] = React.useState({});
  const [validated, setValidated] = React.useState(false);
  const bodyRef = React.useRef(null);

  React.useEffect(() => {
    load();
  }, []);

  const load = function () {
    const path = {};
    const body = {};
    path.budgetOperationId = budgetOperation.budgetOperationId;
    body.janCount = budgetOperation.janCount;
    body.febCount = budgetOperation.febCount;
    body.marCount = budgetOperation.marCount;
    body.aprCount = budgetOperation.aprCount;
    body.mayCount = budgetOperation.mayCount;
    body.junCount = budgetOperation.junCount;
    body.julCount = budgetOperation.julCount;
    body.augCount = budgetOperation.augCount;
    body.sepCount = budgetOperation.sepCount;
    body.octCount = budgetOperation.octCount;
    body.novCount = budgetOperation.novCount;
    body.decCount = budgetOperation.decCount;
    setPath(path);
    setBody(body);
    setValidated(false);
  }
  
  
  const submit = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRef.current)) {
      try {
        await ApiService.putBudgetOperation(path.budgetOperationId, body);
      }
      catch (error) {
        setError(error);
        return;
      }
      window.location.reload();
    }
    else {
      setValidated(true);
    }
  }
  
  const updatePath = function (field, value) {
    setPath({ ...path, [field]: value });
  }
  
  const updateBody = function (field, value) {
    setBody({ ...body, [field]: value });
  }
  
  const cancel = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    window.location.reload();
  }
  return (
    <div>
      <div>
        <div className="p-1 bg-gray-lighter">
          <Title level={2} icon={IconCount} color="blue" label={words.counts} />
        </div>
        <div className="d-flex align-items-center justify-content-end">
        </div>
        <div ref={bodyRef}>
          <div>
            <BudgetOperationTopPart3Part1 budgetOperation={budgetOperation} path={path} updatePath={updatePath} body={body} updateBody={updateBody} validated={validated} />
          </div>
        </div>
        <div className="px-1 py-2 d-flex justify-content-end">
          <div>
            <Button label={words.updateCounts} color="green" onClick={(e) => submit(e)} />
          </div>
          <div className="ps-1">
            <Button label={words.reset} color="blue" onClick={(e) => cancel(e)} />
          </div>
        </div>
      </div>
    </div>
  );
})

export default BudgetOperationTopPart3;
